import * as THREE from 'three';
function mountMark(mount){
  mount.dataset.mounted = '1';
  mount.style.position = 'relative'; mount.style.overflow = 'hidden';
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(32, 1, 0.1, 100);
  camera.position.set(0, 0, 6.4);
  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFShadowMap;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.1;
  renderer.domElement.style.position = 'relative';
  mount.appendChild(renderer.domElement);
  function resize(){ const s = mount.clientWidth || 150; renderer.setSize(s, s); }
  resize();
  new ResizeObserver(resize).observe(mount);

  const ink = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.035, metalness: 1.0, vertexColors: true, envMapIntensity: 3.2 });
  const letterInk = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.03, metalness: 1.0, vertexColors: true, envMapIntensity: 3.4 });
  const capBlack = new THREE.MeshStandardMaterial({ color: 0x2e3133, roughness: 0.05, metalness: 1.0, envMapIntensity: 3.0 });

  function applyGradient(geo, topColor, bottomColor){
    geo.computeBoundingBox();
    const minY = geo.boundingBox.min.y, maxY = geo.boundingBox.max.y;
    const span = Math.max(maxY - minY, 0.0001);
    const pos = geo.attributes.position;
    const colors = new Float32Array(pos.count * 3);
    const c = new THREE.Color();
    for (let i = 0; i < pos.count; i++){
      const t = (pos.getY(i) - minY) / span;
      c.copy(bottomColor).lerp(topColor, t);
      colors[i*3] = c.r; colors[i*3+1] = c.g; colors[i*3+2] = c.b;
    }
    geo.setAttribute('color', new THREE.BufferAttribute(colors, 3));
  }
  const gradTop = new THREE.Color(0x0b0d0e);
  const gradBottom = new THREE.Color(0x000000);

  const mark = new THREE.Group();
  mark.name = 'ei-mark';

  const outer = 2.477, inner = 2.15, frameDepth = 0.22;
  const frameShape = new THREE.Shape();
  frameShape.moveTo(-outer/2, -outer/2);
  frameShape.lineTo(outer/2, -outer/2);
  frameShape.lineTo(outer/2, outer/2);
  frameShape.lineTo(-outer/2, outer/2);
  frameShape.closePath();
  const hole = new THREE.Path();
  hole.moveTo(-inner/2, -inner/2);
  hole.lineTo(inner/2, -inner/2);
  hole.lineTo(inner/2, inner/2);
  hole.lineTo(-inner/2, inner/2);
  hole.closePath();
  frameShape.holes.push(hole);
  const frameGeo = new THREE.ExtrudeGeometry(frameShape, { depth: frameDepth, bevelEnabled: true, bevelThickness: 0.014, bevelSize: 0.012, bevelSegments: 1 });
  frameGeo.center();
  applyGradient(frameGeo, gradTop, gradBottom);
  const frame = new THREE.Mesh(frameGeo, [ink, capBlack]);
  frame.name = 'frame';
  frame.castShadow = true; frame.receiveShadow = true;
  mark.add(frame);

  function bar(w,h,d){ const g = new THREE.BoxGeometry(w,h,d,1,1,1); applyGradient(g, gradTop, gradBottom); const m = new THREE.Mesh(g, [letterInk,letterInk,letterInk,letterInk,capBlack,capBlack]); m.castShadow = true; m.receiveShadow = true; return m; }

  const eGroup = new THREE.Group(); eGroup.name = 'letter-E';
  const eW = 0.988, eH = 1.548, eBarH = 0.150, eMidH = 0.145, eMidW = 0.894, eStemW = 0.1636;
  const eShape = new THREE.Shape();
  eShape.moveTo(0, eH/2);
  eShape.lineTo(eW, eH/2);
  eShape.lineTo(eW, eH/2 - eBarH);
  eShape.lineTo(eStemW, eH/2 - eBarH);
  eShape.lineTo(eStemW, eMidH/2);
  eShape.lineTo(eMidW, eMidH/2);
  eShape.lineTo(eMidW, -eMidH/2);
  eShape.lineTo(eStemW, -eMidH/2);
  eShape.lineTo(eStemW, -eH/2 + eBarH);
  eShape.lineTo(eW, -eH/2 + eBarH);
  eShape.lineTo(eW, -eH/2);
  eShape.lineTo(0, -eH/2);
  eShape.closePath();
  const eGeo = new THREE.ExtrudeGeometry(eShape, { depth: frameDepth, bevelEnabled: true, bevelThickness: 0.009, bevelSize: 0.008, bevelSegments: 1 });
  eGeo.center();
  applyGradient(eGeo, gradTop, gradBottom);
  const eMesh = new THREE.Mesh(eGeo, [letterInk, capBlack]);
  eMesh.castShadow = true; eMesh.receiveShadow = true;
  eMesh.position.set(-0.271,0,0);
  eGroup.add(eMesh);
  mark.add(eGroup);

  const iGroup = new THREE.Group(); iGroup.name = 'letter-I';
  const iVert = bar(0.1636,1.548,frameDepth); iVert.position.set(0.694,0,0);
  iGroup.add(iVert);
  mark.add(iGroup);

  scene.add(mark);
  mark.rotation.set(0, 0, 0);

  const key = new THREE.DirectionalLight(0xffffff, 3.4);
  key.position.set(0,2.4,4.4);
  key.castShadow = true;
  key.shadow.mapSize.set(1024,1024);
  key.shadow.camera.near = 1; key.shadow.camera.far = 12;
  key.shadow.camera.left = -3; key.shadow.camera.right = 3;
  key.shadow.camera.top = 3; key.shadow.camera.bottom = -3;
  key.shadow.radius = 3;
  key.shadow.bias = -0.0025;
  key.shadow.normalBias = 0.02;
  scene.add(key);

  const rim = new THREE.DirectionalLight(0xdfe9ff, 2.2);
  rim.position.set(-4,1.5,-3);
  scene.add(rim);

  const fill = new THREE.DirectionalLight(0xffffff, 0.25);
  fill.position.set(-3,-3,3);
  scene.add(fill);

  scene.add(new THREE.AmbientLight(0xffffff, 0.12));

  const skyCanvas = document.createElement('canvas');
  skyCanvas.width = 8; skyCanvas.height = 256;
  const skyCtx = skyCanvas.getContext('2d');
  const skyTex = new THREE.CanvasTexture(skyCanvas);
  skyTex.mapping = THREE.EquirectangularReflectionMapping;
  skyTex.colorSpace = THREE.SRGBColorSpace;
  scene.environment = skyTex;

  const animatedGeos = [frameGeo, eGeo, iVert.geometry];

  const skyStops = [
    { top:new THREE.Color(0x2f6fb0), horizon:new THREE.Color(0xbfe0f2) },
    { top:new THREE.Color(0xc9762f), horizon:new THREE.Color(0xffce8a) },
    { top:new THREE.Color(0x5a1f2b), horizon:new THREE.Color(0xd9502f) },
  ];
  function drawSky(top, horizon){
    const topHex = '#'+top.getHexString();
    const midHex = '#'+top.clone().lerp(horizon,0.6).getHexString();
    const horizonHex = '#'+horizon.getHexString();
    const g = skyCtx.createLinearGradient(0,0,0,skyCanvas.height);
    g.addColorStop(0, topHex);
    g.addColorStop(0.6, midHex);
    g.addColorStop(1, horizonHex);
    skyCtx.fillStyle = g;
    skyCtx.fillRect(0,0,skyCanvas.width,skyCanvas.height);
    skyCtx.fillStyle = 'rgba(255,255,255,0.92)';
    skyCtx.fillRect(0, skyCanvas.height*0.30, skyCanvas.width, skyCanvas.height*0.05);
    skyCtx.fillRect(0, skyCanvas.height*0.62, skyCanvas.width, skyCanvas.height*0.035);
    skyCtx.fillStyle = 'rgba(0,0,0,0.65)';
    skyCtx.fillRect(0, skyCanvas.height*0.12, skyCanvas.width, skyCanvas.height*0.06);
    skyCtx.fillRect(0, skyCanvas.height*0.80, skyCanvas.width, skyCanvas.height*0.07);
    skyCtx.fillStyle = 'rgba(255,255,255,0.55)';
    skyCtx.fillRect(0, skyCanvas.height*0.0, skyCanvas.width, skyCanvas.height*0.03);
    skyTex.needsUpdate = true;
  }
  drawSky(skyStops[0].top, skyStops[0].horizon);

  let scrollRot = 0;
  function onScroll(){
    const maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const distFromBottom = maxScroll - window.scrollY;
    const bottomZone = 500;
    let rot = window.scrollY * 0.0025;
    if (distFromBottom < bottomZone){
      rot *= Math.max(0, distFromBottom / bottomZone);
    }
    scrollRot = rot;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  let t = Math.random() * 1000;
  const cycleSeconds = 45;
  const tmpTop = new THREE.Color(), tmpHorizon = new THREE.Color(), tmpKey = new THREE.Color();
  const boostTop = new THREE.Color(), boostHorizon = new THREE.Color();
  const hsl = { h:0, s:0, l:0 };
  function boost(src, dst, satBoost, lightBoost){
    src.getHSL(hsl);
    dst.setHSL(hsl.h, Math.min(1, hsl.s * satBoost), Math.min(0.72, hsl.l * lightBoost));
  }
  function tick(){
    const phase = (t / cycleSeconds) % 1;
    const seg = phase * skyStops.length;
    const i0 = Math.floor(seg) % skyStops.length;
    const i1 = (i0 + 1) % skyStops.length;
    const f = seg - Math.floor(seg);
    tmpTop.copy(skyStops[i0].top).lerp(skyStops[i1].top, f);
    tmpHorizon.copy(skyStops[i0].horizon).lerp(skyStops[i1].horizon, f);
    drawSky(tmpTop, tmpHorizon);
    tmpKey.copy(tmpHorizon).lerp(new THREE.Color(0xffffff), 0.35);
    key.color.copy(tmpKey);
    rim.color.copy(tmpTop).lerp(new THREE.Color(0xffffff), 0.5);
    boost(tmpTop, boostTop, 1.6, 2.0);
    boost(tmpHorizon, boostHorizon, 1.5, 1.7);
    animatedGeos.forEach(g => applyGradient(g, boostTop, boostHorizon));
  }
  let smoothRot = 0;
  function animate(){
    requestAnimationFrame(animate);
    if (mount.offsetParent === null) return;
    t += 0.011;
    smoothRot += (scrollRot - smoothRot) * 0.035;
    mark.rotation.y = smoothRot;
    mark.rotation.x = smoothRot * 0.4;
    mark.rotation.z = 0;
    mark.position.y = 0;
    tick();
    renderer.render(scene, camera);
  }
  animate();
}
document.querySelectorAll('.header-3d-mark').forEach(function(el){ if(!el.dataset.mounted) mountMark(el); });
